// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2TlDG","question":"styles_question__3Kos6","inputVisibleButton":"styles_inputVisibleButton__1hCRU","note":"styles_note__3r8Q_"};